import React, { useEffect, useMemo, useRef } from 'react';
import { Column } from 'devextreme-react/data-grid';
import { Item as TabItem } from "devextreme-react/tab-panel";
import Form, { GroupItem, SimpleItem, Label, FormRef } from "devextreme-react/form";
import IEspece from "../../models/IEspece";
import { FormListBase, FormListBaseTab, FormListBaseGrid, FormListBaseToolbar } from '../base';
import useCustomDataSource, { Mode } from "../../hooks/useCustomDataSource";
import FormSysteme from '../../components/forms/form-systeme';
import useEnum from '../../hooks/useEnum';
import { useContextPopupPage } from '../../components/popups/PopupPage';

interface IPopupGestionEspecesProps {
  isModeSelection?: boolean,
}

export default function GestionEspeces({ isModeSelection }: IPopupGestionEspecesProps) {
  const clientFormDataSource = useCustomDataSource<IEspece, IEspece>({ path: "espece", primaryKey: "idEspece" });
  const { selectedDataRow: selectedEspece, mode, setMainForm, setMode, isFieldModifier, setIsFieldModifier, onFieldDataChanged } = clientFormDataSource;
  const { setSelectedValue } = useContextPopupPage();
  const formRef = useRef<FormRef>(null);

  useEffect(() => {
    setMainForm(formRef.current?.instance());
  });

  useEffect(() => {
    if (mode !== Mode.Lecture) formRef.current?.instance().getEditor("description")?.focus();
  }, [mode]);

  const { editorOptions: especesOptions } = useEnum(undefined, "gestionEspeces");
  const descriptionOptions = useMemo(() => {
    return { maxLength: 50 };
  }, []);
  const actifOptions = useMemo(() => {
    return { text: "Actif" };
  }, []);
  const facteursEditorOptions = useMemo(() => {
    return {
      format: {
        type: "fixedPoint",
        precision: 2,
        thousandsSeparator: " ",
        decimalSeparator: ","
      },
      min: 0,
      step: 0.01,
      width: 69,
      inputAttr: { style: 'text-align: right;' }
    };
  }, []);
  const limitePossessionEditorOptions = useMemo(() => {
    return {
      width: 69,
      inputAttr: { style: 'text-align: right;' }
    };
  }, []);

  return (
    <FormListBase data={clientFormDataSource}>
      <FormListBaseGrid dataSource={clientFormDataSource.dataSource}
        onFocusedRowChanged={(e: any) => {
          if (mode === Mode.Modifier) {
            setMode(Mode.Lecture)
          }
          if (setSelectedValue && e.row?.data) {
            setSelectedValue(e.row.data);
          }
        }}
      >
        <Column key={"grid-col-description"} dataField={"description"} caption="Description" allowHiding={false} />
      </FormListBaseGrid>
      <FormListBaseToolbar headerText={`Groupe#${selectedEspece?.description || ''}`} sauvegarderOptions={{ disabled: !isFieldModifier }} annulerOptions={{ disabled: !isFieldModifier }} />
      {!isModeSelection || isModeSelection && mode !== Mode.Lecture
        ? <FormListBaseTab>
          <TabItem title="Informations">
            <div style={{ height: "100%", paddingBottom: "1rem" }}>
              <Form ref={formRef} readOnly={mode === Mode.Lecture} alignItemLabelsInAllGroups={true} formData={selectedEspece || {} as IEspece} className={"forms"} labelLocation={"left"} showColonAfterLabel={true} onFieldDataChanged={onFieldDataChanged}>
                <GroupItem>
                  <GroupItem colCount={2}>
                    <SimpleItem key={"frm-description"} dataField={"description"}
                      editorOptions={
                        descriptionOptions
                      } />
                    <SimpleItem key={"frm-actif"} dataField={"actif"} editorType={"dxCheckBox"}
                      editorOptions={
                        actifOptions
                      }
                    >
                      <Label visible={false} />
                    </SimpleItem>
                  </GroupItem>
                  <SimpleItem editorOptions={facteursEditorOptions} key={"frm-facteur-convertion-eviscere"} dataField={"facteurConversionEviscere"} editorType={'dxNumberBox'}>
                    <Label showColon={false} text={"Facteur de conversion éviscéré"} />
                  </SimpleItem>
                  <SimpleItem editorOptions={facteursEditorOptions} key={"frm-facteur-conversion-etete"} dataField={"facteurConversionEtete"} editorType={'dxNumberBox'}>
                    <Label showColon={false} text={"Facteur conversion étêté"} />
                  </SimpleItem>
                  <SimpleItem editorOptions={facteursEditorOptions} key={"frm-facteur-conversion-non-pese"} dataField={"facteurConversionNonPese"} editorType={'dxNumberBox'}>
                    <Label showColon={false} text={"Facteur conversion non pesé"} />
                  </SimpleItem>
                  <SimpleItem editorOptions={limitePossessionEditorOptions} key={"frm-limite-possession"} dataField={"limitePossession"} editorType={'dxNumberBox'}>
                    <Label showColon={false} text={"Limite de possession"} />
                  </SimpleItem>
                </GroupItem>
                <GroupItem caption={"Espèce"} cssClass='radio-group'>
                  <SimpleItem cssClass='radio-group-items' key={"frm-id-espece"} dataField={"noEspece"} editorType={"dxRadioGroup"}
                    editorOptions={
                      especesOptions
                    }>
                    <Label visible={false} />
                  </SimpleItem>
                </GroupItem>
              </Form>
            </div>
          </TabItem>
          <TabItem title="Système"><FormSysteme formData={selectedEspece || {} as IEspece} /></TabItem>
        </FormListBaseTab>
        : null}
    </FormListBase>
  );
}
